import React from "react";

const Privacy = () => {
  return (
    <div className="bg-white">
      <section className="relative w-full overflow-hidden">
        <div className="relative w-full h-[300px] md:h-[360px] flex">
          <div
            className="relative z-10 flex items-center text-white"
            style={{
              width: "55%",
              backgroundColor: "#e11d7b",
              clipPath: "polygon(0 0, 100% 0, 92% 35%, 78% 100%, 0 100%)"
            }}
          >
            <div className="max-w-xl pl-8 md:pl-16 pr-10">
              <h1 className="text-4xl md:text-5xl font-extrabold leading-tight">
                Politique de confidentialité
              </h1>
              <p className="mt-4 text-base md:text-lg text-white/90">
                Protection des données personnelles
              </p>
            </div>
          </div>

          <div
            className="absolute right-0 top-0 h-full w-full"
            style={{
              background:
                "linear-gradient(to right, #e11d7b 0%, rgba(225,29,123,0.55) 45%, rgba(225,29,123,0.15) 70%, transparent 100%)"
            }}
          />
        </div>
      </section>

      <section className="py-12 bg-[#fff3f8]">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white border rounded-2xl p-6 text-gray-700 leading-relaxed">
            <h2 className="text-xl font-bold text-gray-900">Données collectées</h2>
            <p className="mt-2">
              Nous collectons uniquement les informations nécessaires (compte, commandes, contact, réservation,
              paiement, support).
            </p>

            <h2 className="text-xl font-bold text-gray-900 mt-6">Utilisation</h2>
            <p className="mt-2">
              Les données servent à exécuter vos demandes (commande/coupon), améliorer le service, et assurer la
              sécurité.
            </p>

            <h2 className="text-xl font-bold text-gray-900 mt-6">Partage</h2>
            <p className="mt-2">
              Les informations peuvent être partagées uniquement avec les partenaires concernés pour exécuter la
              prestation (réservation, contrôle coupon).
            </p>

            <h2 className="text-xl font-bold text-gray-900 mt-6">Suppression</h2>
            <p className="mt-2">
              Vous pouvez demander la suppression de vos informations à : <b>contact@maxula.ma</b>.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Privacy;
